// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"65a3dd64","177":"821b7a28","265":"52fdeddb","334":"110bcbf0","512":"f8534590","623":"7480e075","629":"91d83db0","670":"e1300da3","832":"769bc688"}[chunkId] + ".chunk.js";
};